import React, { useState } from "react";
import "./TestimonialSlider.css";

const TestimonialSlider = () => {
  const testimonials = [
    {
      id: 1,
      name: "Joanna Prestley",
      title: "Absolutely spot-on!",
      text: "Seamlessly visualize quality intellectual capital without superior collaboration and idea-sharing.",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop",
    },
    {
      id: 2,
      name: "Bradley Smith",
      title: "Best decision ever",
      text: "Quickly deploy strategic networks with compelling e-business. Credibly pontificate manufactured products.",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop",
    },
    {
      id: 3,
      name: "Priscilla Jackson",
      title: "Saved my Business",
      text: "Objectively integrate emerging core competency communities. Dynamically target high-payoff intellectual capital.",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop",
    },
    {
      id: 4,
      name: "Collin Leblanc",
      title: "All the right answers",
      text: "Efficiently enable cost-effective products and completely synthesize principle-centered information.",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop",
    },
    {
      id: 5,
      name: "Crystal Harper",
      title: "Amazing Support!",
      text: "Their support team is outstanding. They helped us scale very fast with zero downtime.",
      image: "https://randomuser.me/api/portraits/women/65.jpg",
    },
    {
      id: 6,
      name: "James Carter",
      title: "Super Helpful",
      text: "The best HR consulting decision we ever made. Their team really understands our vision.",
      image: "https://randomuser.me/api/portraits/men/51.jpg",
    },
    {
      id: 7,
      name: "Lydia Rose",
      title: "Highly Recommended",
      text: "Excellent expertise and smooth workflow. They became an extension of our internal team.",
      image: "https://randomuser.me/api/portraits/women/32.jpg",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const itemsPerView = 4;
  const maxIndex = testimonials.length - itemsPerView;

  const handleDotClick = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="tsto-container">
      {/* Header */}
      <div className="tsto-header">
        <div className="tsto-header-left">
          <p className="tsto-subtitle">BUSINESS ARE FINDING GREAT EMPLOYEES</p>
        </div>
        
        <div className="tsto-header-center">
          <h1 className="tsto-title">
            <span className="tsto-title-red">Trusted by Biggest</span>
            <br />
            <span className="tsto-title-dark">Business Names</span>
          </h1>
        </div>
        
        <div className="tsto-header-right">
          <p className="tsto-description">
            Our clients have always trusted our expertise and advices. Here's what they have to say about us.
          </p>
        </div>
      </div>

      {/* Slider */}
      <div className="tsto-carousel-wrapper">
        <div
          className="tsto-carousel-track"
          style={{ transform: `translateX(-${currentIndex * (100 / itemsPerView)}%)` }}
        >
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="tsto-card">
              <img src={testimonial.image} className="tsto-avatar" alt={testimonial.name} />
              <h3 className="tsto-card-title">{testimonial.title}</h3>
              <p className="tsto-text">{testimonial.text}</p>

              <div className="tsto-stars">
                {[...Array(5)].map((_, i) => (
                  <span key={i}>★</span>
                ))}
              </div>

              <p className="tsto-name">{testimonial.name}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Dots */}
      <div className="tsto-dots">
        {[...Array(maxIndex + 1)].map((_, index) => (
          <button
            key={index}
            className={`tsto-dot ${currentIndex === index ? "tsto-active" : ""}`}
            onClick={() => handleDotClick(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default TestimonialSlider;